module.exports = __webpack_public_path__ + "img/IMG_3697.f22215f7.jpg";